import { Link } from 'react-router-dom';
import { comparisonPlatforms } from '@/mocks/categories';

export default function ComparisonSection() {
  return (
    <section id="comparisons" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 text-foreground-600 text-xs font-semibold uppercase tracking-wider mb-4">
            Platform Comparison
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Spreadsheet Platform Comparison
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            See how Kakobuy Spreadsheet stacks up against other popular shopping spreadsheet platforms.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="py-4 px-4 text-sm font-semibold text-foreground-700">Platform</th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-700">Spreadsheet Resource</th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-700">Product Discovery</th>
                <th className="py-4 px-4 text-sm font-semibold text-foreground-700">User Experience</th>
              </tr>
            </thead>
            <tbody>
              {comparisonPlatforms.map((platform) => (
                <tr
                  key={platform.name}
                  className={`border-b border-background-200/50 ${
                    platform.highlight ? 'bg-primary-50/40' : ''
                  }`}
                >
                  <td className="py-4 px-4">
                    <span className={`text-sm font-semibold ${platform.highlight ? 'text-primary-700' : 'text-foreground-800'}`}>
                      {platform.name}
                    </span>
                    {platform.highlight && (
                      <span className="ml-2 inline-block px-2 py-0.5 rounded-full bg-primary-200 text-primary-800 text-[10px] font-bold uppercase">
                        Best
                      </span>
                    )}
                  </td>
                  <td className="py-4 px-4 text-sm text-foreground-700">{platform.resource}</td>
                  <td className="py-4 px-4 text-sm text-foreground-700">{platform.discovery}</td>
                  <td className="py-4 px-4 text-sm text-foreground-700">{platform.experience}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read Detailed Comparison Guide
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}